import { apiClient } from "../../services/apiService";
export interface Progress {
  goal: string | null;
  books: string | null;
  configured_at: string | null;
  example_inspected_at: string | null;
  example_saved_at: string | null;
  first_value_at: string | null;
  /** First tracked single bet with a closing line result. */
  activated_at?: string | null;
  first_aha_at: string | null;
  returned_at: string | null;
  return_line: string | null;
  billing_status: string | null;
  plan: string | null;
  trial_end: string | null;
  period_end: string | null;
  billing_amount_cents?: number | null;
  billing_interval?: string | null;
  /** First charge plus the refund window. Null until there is a first charge. */
  refund_window_end?: string | null;
  canceling: boolean;
  collection_paused: boolean;
  billing_review: boolean;
  payment_verified: boolean;
  billing_pending: boolean;
  billing_synced_at: string | null;
  marketing_paused: boolean;
}
export const readProgress = async (): Promise<Progress> =>
  (await apiClient.get("/api/v1/lifecycle/me")).data;
export const saveProgress = async (
  action: string,
  goal?: string,
  books?: string,
): Promise<Progress> =>
  (
    await apiClient.post("/api/v1/lifecycle/me/progress", {
      action,
      goal,
      books,
    })
  ).data;
export interface WinBackOffer {
  eligible: boolean;
  expires_at: string | null;
}
export const readWinBackOffer = async (): Promise<WinBackOffer> =>
  (await apiClient.get("/api/v1/lifecycle/win-back-offer")).data;
export type ReactivationAction =
  | "NONE"
  | "KEEP"
  | "EXTRA_WEEK"
  | "WIN_BACK_RATE";
export interface Reactivation {
  action: ReactivationAction;
  billing_status: string | null;
  access_end: string | null;
  next_charge_at: string | null;
  next_charge_cents: number | null;
}
export const readReactivation = async (): Promise<Reactivation> =>
  (await apiClient.get("/api/v1/lifecycle/reactivation")).data;
/** Sends no offer and no price. The server decides what this person gets. */
export const reactivate = async (): Promise<Reactivation> =>
  (await apiClient.post("/api/v1/lifecycle/reactivation")).data;
export const pauseMarketing = async () =>
  apiClient.post("/api/v1/lifecycle/me/pause-marketing");

/** Authenticated, daily-deduplicated product interactions. Never blocks board access. */
export function recordProductActivity(
  action:
    | "board_opened_ev"
    | "board_opened_arb"
    | "setup_applied_ev"
    | "setup_applied_arb",
) {
  void apiClient
    .post("/api/v1/lifecycle/me/progress", { action })
    .catch(() => undefined);
}
export const verifyCheckout = async (
  id: string,
): Promise<{
  complete: boolean;
  newly_confirmed: boolean;
  session_id: string;
  tier: string | null;
}> =>
  (await apiClient.get(`/api/v1/lifecycle/checkout/${encodeURIComponent(id)}`))
    .data;
/** Server timestamps are UTC LocalDateTimes with no zone on the wire. */
export function parseUtc(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(
    /[Zz]|[+-]\d\d:\d\d$/.test(value) ? value : `${value}Z`,
  );
  return Number.isNaN(date.getTime()) ? null : date;
}
export function utcDate(value: string | null | undefined): string {
  if (!value) return "Not recorded";
  const date = new Date(
    /[Zz]|[+-]\d\d:\d\d$/.test(value) ? value : `${value}Z`,
  );
  return Number.isNaN(date.getTime())
    ? "Not recorded"
    : date.toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
      });
}
